import React, {useEffect, useState} from 'react';
import {Input, Divider} from 'antd';
import cls from 'classname';
import './styles.less';
import InterestTargetingTable from './InterestTargetingTable';
import Icon from '../../../../Icon';
import axios from "axios";
import {debounce} from "../../../../Utils/utils";

export default function InterestTargeting() {

  const [searchText, setSearchText] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [focusedSearch, setFocusedSearch] = useState(false);
  const [fetching, setFetching] = useState(false)
  const [tableData, setTableData] = useState([])
  const [tableDataCopy, setTableDataCopy] = useState([])
  const [selected, setSelected] = useState([])
  const [next, setNext] = useState('')
  const {Search} = Input;

  const getInterestTarget = (data) => {
    try {
      setFetching(true)
      const resp = axios.get('https://api.dropship.io/api/interests/landing/', {params: data})
      resp.then(res => {
        if (res.status && res.data) {
          setTableData(res.data.results)
          setNext(res.data.next)
        }
        resp.catch(error => console.log(error))
        resp.finally(() => setFetching(false))
      })
    } catch (error) {
      console.log(error)
      setFetching(false)
    }
  }

  const getInterestTargetNext = (link) => {
    try {
      setFetching(true)
      const resp = axios.get(link)
      resp.then(res => {
        if (res.status && res.data) {
          setTableData(state => ([...state,...res.data.results]))
          setNext(res.data.next)
        }
        resp.catch(error => console.log(error))
        resp.finally(() => setFetching(false))
      })
    } catch (error) {
      console.log(error)
      setFetching(false)
    }
  }

  useEffect(() => {
    getInterestTarget(null)
  }, [])

  useEffect(() => {
    getInterestTarget({q: searchText, ordering: sortOrder})
  }, [searchText, sortOrder])

  useEffect(() => {
    setTableDataCopy([...tableData])
  }, [tableData])

  function handleSort({order, field}) {
    if (order) {
      const ordering = order === 'ascend' ? field : `-${field}`;
      setSortOrder(ordering);
    } else {
      setSortOrder(null);
    }
  }

  const handleSearch = debounce((value) => {
    if (value === '') setSearchText(null)
    else setSearchText(value)
  }, 300)

  function handleChange(e) {
    const {checked, value} = e.target
    if (checked) {
      let interest = tableDataCopy.filter(el => el.id === value)
      setSelected(state => ([...state, ...interest]))
    } else {
      let selectedCopy = [...selected.filter(el => el.id !== value)]
      setSelected([...selectedCopy])
      setTableDataCopy(state => state.sort((a, b) => a.id - b.id ))
    }
      setTableDataCopy(state => state.map(el => {
        if (el.id === value)
          return {...el, selected: checked}
        else return el
      }))
  }

  const handleSave = () => {
    let newArray = [...tableDataCopy]
    selected.forEach(interest => {
      console.log('interest',interest)
        newArray = newArray.map(el => {
          if (el.id === interest.id) {
            return {...el, selected: true}
          }
          else return el
        })
      if (newArray.findIndex(e => e.id === interest.id) === -1) {
        newArray.unshift(interest)
      }
    })
    newArray.sort(function (x, y) {
      return (x.selected === y.selected) ? 0 : x.selected ? -1 : 1;
    })
    setTableDataCopy([...newArray])
  }

  return (
    <div className="interest-targeting-block">
      <div className="block-with-label">
        <div className="block-with-label_label space-between bold-text">
          <div style={{display: 'none'}}>Interest Targeting <span className="important">*</span></div>
          <div className={'interests-approved'}><span>{selected.length}</span><span> Saved</span></div>
        </div>
      </div>
      <div className="container container--table-view interest--targeting">
        <div className="search">
          <div className="search_wrapper">
            <Search
              placeholder="Search for interests..."
              className={cls('search-input', 'interests-search')}
              onChange={(e) => {
                e.persist();
                handleSearch(e.target.value.trim())
              }}
              onSearch={handleSave}
              onFocus={() => setFocusedSearch(true)}
              onBlur={() => setFocusedSearch(false)}
              enterButton="Saved"
              size="large"
              prefix={
                <>
                  <Icon type="search_icon" role="icon" color={focusedSearch ? '#225aea' : '#707ba0'}/>
                  <Divider type="vertical" className="search-divider"/>
                </>
              }
            />
          </div>
        </div>
        <div className="interest-list">
          <InterestTargetingTable
            interests={tableDataCopy}
            onSort={handleSort}
            searchText={searchText}
            getInterestTargetNext={getInterestTargetNext}
            next={next}
            fetching={fetching}
            onChange={handleChange}
          />
          {
            fetching &&
            <div className="interest-list-loader">
              <div className="loader-2 center">
                <span/>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
